import React from 'react';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CollectionQueryForm from 'Components/ComponentLibrary/Molecules/CollectionQueryForm';
import fr from 'facet-rest';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import RoundedToggleAttributeButton from 'Components/ComponentLibrary/Molecules/RoundedToggleAttributeButton';
import SearchInput from 'Components/ComponentLibrary/Molecules/SearchInput';
import {
  ThreadListHeaderLayout,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/ThreadListHeaderLayout';

const metaOverrideSet = fr.metaOverride()
  .typeOverride('bool', {
    _component: () => RoundedToggleAttributeButton,
  })
  .nameOverride('search', {
    _component: () => SearchInput,
  });

const useStyles = buildUseStyles('ThreadListHeader', () => ({
  root: {
    minHeight: 0,
    flex: '0 0 auto',
  },
}));

const ThreadListHeader = () => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const {
    threadsCollection,
    setThreadsCollectionWithClear,
  } = useMessagesContext();

  return (
    <CollectionQueryForm
      className={classes.root}
      formPadding={'none'}
      formMargin={'none'}
      layout={ThreadListHeaderLayout}
      collection={threadsCollection}
      metaOverrideSet={metaOverrideSet}
      onSubmit={(filterResultCollection) => {
        setThreadsCollectionWithClear(filterResultCollection);
      }}
    />
  );
};

ThreadListHeader.defaultProps = {
};

ThreadListHeader.propTypes = {
};

export { ThreadListHeader };
